export default __webpack_public_path__ + "static/media/CLV_token.cd22c703.svg";